import moment from "moment";
import { ClipboardEvent, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
//@ts-ignore
import { toast } from "react-toastify";
import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../customHooks/useGetHook";
import { useSessionStorage } from "@uidotdev/usehooks";
import { IFilterManifest } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import { classNames } from "../Reusable/DatePicker/helpers";
import ManifestFilter from "./Filter";
import TabPanel from "../Reusable/Tab";

const ReceiveManifestList = (props: any) => {
  const { defaultBranch, handlecheckConsignments } = props;
  const navigate = useNavigate();
  const [localState, handleSetState] = useSessionStorage<IFilterManifest>(
    "recieve-manifest-filter",
    {
      created__range: null,
      vehicle: null,
      driver: null,
      owner_branch: null,
    }
  );
  const [active, setActive] = useState("");
  const [is_received, SetISReceived] = useState(null);
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));

  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterManifest>({
      defaultValues: async () => {
        return {
          vehicle: localState?.vehicle ?? null,
          created__range: localState?.created__range ?? null,
          driver: localState?.driver ?? null,
          owner_branch: localState?.owner_branch ?? null,
        };
      },
    });

  const handleFilterReset = () => {
    reset({
      vehicle: null,
      created__range: null,
      driver: null,
      owner_branch: null,
    });
  };

  const { register, setError } = useForm({
    defaultValues: { tracking_number: "" },
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      handlecheckConsignments(event.target.value, setError);
      event.target.value = "";
    }
  };
  const defaultColumns: any = [
    {
      header: "Manifest ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "origin.name",
      cell: NACell,
    },
    {
      header: "D. Branch",
      accessorKey: "destination_branch.name",
      cell: NACell,
    },

    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Received Items",
      accessorKey: "items.received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Missing Items",
      accessorKey: "items.missing",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  const orderDefaultColumns: any = [
    {
      header: "Waybill",
      accessorKey: "order.tracking_number",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "order.sender.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Weight/Pcs",
      accessorKey: "order.weight",
      cell: NACell,
    },
    {
      header: "Received",
      accessorKey: "is_received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
                  stroke="#26C943"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="red"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </>
        );
      },
    },
  ];
  const filterParams = watch();

  const { data: manifestreport, isLoading: isDataLoading } = useGetHook({
    queryKey: [`manifest-report`],
    url: `${APIS.MANIFEST_REPORT}`,
    params: {},
  });
  const handleDetailNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  const handleRunsheetNavigate = () => {
    navigate("/courier-delivery");
  };
  const handleOrderDetailNavigate = (row: any) => {
    console.info(row);
  };

  useEffect(() => {
    if (active === "pending_manifest") {
      SetISReceived(false);
    } else {
      SetISReceived(null);
    }
  }, [active]);

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <ManifestFilter
          isFilterVisible={isFilterVisible}
          reset={handleFilterReset}
          control={control}
          setValue={setValue}
          getValues={getValues}
        />
      </Card>
      <TabPanel
        tabTitle={["Pending Manifest", " Receive Manifest"]}
        tabPanels={[
          <DataTable
            url={`${APIS.MANIFEST_ITEMS}`}
            queryKey={"manifest-items"}
            tableName="pending-manifest"
            columns={orderDefaultColumns}
            params={{
              is_received: false,
              destination_branch: defaultBranch?.id,
              is_final_status: true,
            }}
            handleDetailNavigate={handleOrderDetailNavigate}
            actionMenu={
              <>
                <div
                  className={tw`w-full justify-end flex items-center gap-x-10 mx-2`}
                >
                  <input
                    type="text"
                    {...register("tracking_number")}
                    className={tw`w-4/5 focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                    onPaste={preventCopyPaste}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    className={tw`px-4 py-2 bg-primary-light text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                    onClick={() => {
                      setActive("pending_manifest");
                    }}
                  >
                    Manifest:{manifestreport?.pending_manifest}
                  </button>

                  <button
                    className={classNames(
                      active === "pending_order"
                        ? tw`bg-primary-active`
                        : tw`bg-primary-light`,
                      tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                    )}
                    onClick={() => {
                      active === "pending_order"
                        ? setActive("")
                        : setActive("pending_order");
                    }}
                  >
                    Consignment:{manifestreport?.pending}
                  </button>
                  <button
                    className={tw`px-4 py-2  text-primary rounded-md bg-primary-light focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 whitespace-nowrap`}
                    onClick={handleRunsheetNavigate}
                  >
                    Delivery Runsheet
                  </button>
                </div>
              </>
            }
          />,
          <DataTable
            url={`${APIS.MANIFEST}receive-manifest`}
            queryKey={"manifest"}
            orderSearch={true}
            tableName="receive-manifest"
            params={{
              type: "receive",
              is_active: false,
              parent__isnull: true,
              is_received: is_received,
              ...params(),
            }}
            handleDetailNavigate={handleDetailNavigate}
            columns={defaultColumns}
            actionMenu={
              <>
                <div
                  className={tw`w-full justify-end flex items-center gap-x-10 mx-2`}
                >
                  <button
                    className={classNames(
                      active === "pending_manifest"
                        ? tw`bg-primary-active`
                        : tw`bg-primary-light`,
                      tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                    )}
                    onClick={() => {
                      active === "pending_manifest"
                        ? setActive("")
                        : setActive("pending_manifest");
                    }}
                  >
                    Manifest:{manifestreport?.pending_manifest}
                  </button>

                  <button
                    className={tw`px-4 py-2 bg-primary-light text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                    onClick={() => {
                      setActive("pending_order");
                    }}
                  >
                    Consignment:{manifestreport?.pending}
                  </button>
                  <button
                    className={tw`px-4 py-2  text-primary rounded-md bg-primary-light focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                    onClick={handleRunsheetNavigate}
                  >
                    Delivery Runsheet
                  </button>
                </div>
              </>
            }
          />,
        ]}
      />
      {/* {active === "pending_order" ? (
        <DataTable
          url={`${APIS.MANIFEST_ITEMS}`}
          queryKey={"manifest-items"}
          tableName="pending-manifest"
          columns={orderDefaultColumns}
          params={{
            is_received: false,
            destination_branch: defaultBranch?.id,
            is_final_status: true,
          }}
          handleDetailNavigate={handleOrderDetailNavigate}
          actionMenu={
            <>
              <div
                className={tw`w-full justify-end flex items-center gap-x-10 mx-2`}
              >
                <div className={tw`w-3/5`}>
                  <div>
                    <input
                      type="text"
                      {...register("tracking_number")}
                      className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                      onPaste={preventCopyPaste}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
                <button
                  className={tw`px-4 py-2 bg-primary-light text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={() => {
                    setActive("pending_manifest");
                  }}
                >
                  Manifest:{manifestreport?.pending_manifest}
                </button>

                <button
                  className={classNames(
                    active === "pending_order"
                      ? tw`bg-primary-active`
                      : tw`bg-primary-light`,
                    tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                  )}
                  onClick={() => {
                    active === "pending_order"
                      ? setActive("")
                      : setActive("pending_order");
                  }}
                >
                  Consignment:{manifestreport?.pending}
                </button>
                <button
                  className={tw`px-4 py-2  text-primary rounded-md bg-primary-light focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={handleRunsheetNavigate}
                >
                  Delivery Runsheet
                </button>
              </div>
            </>
          }
        />
      ) : (
        <DataTable
          url={`${APIS.MANIFEST}receive-manifest`}
          queryKey={"manifest"}
          orderSearch={true}
          tableName="receive-manifest"
          params={{
            type: "receive",
            is_active: false,
            parent__isnull: true,
            is_received: is_received,
            ...params(),
          }}
          handleDetailNavigate={handleDetailNavigate}
          columns={defaultColumns}
          actionMenu={
            <>
              <div
                className={tw`w-full justify-end flex items-center gap-x-10 mx-2`}
              >
                <button
                  className={classNames(
                    active === "pending_manifest"
                      ? tw`bg-primary-active`
                      : tw`bg-primary-light`,
                    tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                  )}
                  onClick={() => {
                    active === "pending_manifest"
                      ? setActive("")
                      : setActive("pending_manifest");
                  }}
                >
                  Manifest:{manifestreport?.pending_manifest}
                </button>

                <button
                  className={tw`px-4 py-2 bg-primary-light text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={() => {
                    setActive("pending_order");
                  }}
                >
                  Consignment:{manifestreport?.pending}
                </button>
                <button
                  className={tw`px-4 py-2  text-primary rounded-md bg-primary-light focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={handleRunsheetNavigate}
                >
                  Delivery Runsheet
                </button>
              </div>
            </>
          }
        />
      )} */}
    </>
  );
};

export default ReceiveManifestList;
